import React, {useState} from 'react'
import {Card, Inline, Loading} from "@therms/atalaya"
import {useApi} from "@src/hooks/useApi"
import {GetInvoices} from "@src/services/api-client"

export function InvoiceHistoryViewer(){

    const [offset, setOffset] = useState(0)
    const { data, isCalling } = useApi(GetInvoices, {offset})
    return(
        <Card className="mb-4">
            <Loading overlay visible={isCalling}/>
            <div className="mb-base overflow-x-auto">
                <table className="w-full text-color-neutral" style={{minWidth: 500}}>
                    <thead>
                        <tr className="font-bold whitespace-nowrap">
                            <td className="pr-4 pb-1">Invoice #</td>
                            <td className="pr-4 pb-1">Date</td>
                            <td className="pr-4 pb-1">Invoice Total</td>
                            <td className="pr-4 pb-1">Status</td>
                            <td className="pb-1">Link</td>
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).map(inv => (
                            <tr key={inv.invoiceNumber} className="italic">
                                <td className="pr-4 pb-1">{inv.invoiceNumber}</td>
                                <td className="pr-4 pb-1">{inv.month}/{inv.day}/{inv.year}</td>
                                <td className="pr-4 pb-1">${(inv.totalCents / 100).toFixed(2)}</td>
                                <td className="pr-4 pb-1">{inv.status === 'Delinquent' ? <Inline className="text-color-critical">Past Due</Inline> : inv.status}</td>
                                <td className="pb-1"><a className="text-color-info" href={inv.viewLink}>View</a></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </Card>
    )
}
